// DOMAINS
const domain0 = [80, 120];
const domain1 = [80, 120];
const domain2 = [0, 25];
const domain3 = [0, 25];
const domain4 = [0, 2.5];
const domain5 = [0, 5];

// export
exports.domain0 = domain0;
exports.domain1 = domain1;
exports.domain2 = domain2;
exports.domain3 = domain3;
exports.domain4 = domain4;
exports.domain5 = domain5;



// TICK VALUES
const tickValues0 = [80, 90, 100, 110, 120];
const tickValues1 = [80, 90, 100, 110, 120];
const tickValues2 = [0, 5, 10, 15, 20, 25];
const tickValues3 = [0, 5, 10, 15, 20, 25];
const tickValues4 = [0, 0.5, 1.0, 1.5, 2.0, 2.5];
const tickValues5 = [0, 1, 2, 3, 4, 5];

// export
exports.tickValues0 = tickValues0;
exports.tickValues1 = tickValues1;
exports.tickValues2 = tickValues2;
exports.tickValues3 = tickValues3;
exports.tickValues4 = tickValues4;
exports.tickValues5 = tickValues5;

// BAR TICK Values
const yTickValuesBars = [1977,
						 1980,
						 1990,
						 2000,
						 2010,
						 2020,
						 2023
						];

// export
exports.yTickValuesBars = yTickValuesBars;


// BAR TICK LABELS
const yTickLabelBars = ['1977', 
						'\'80',
						'\'90',
						'2000',
						'\'10',
						'\'20',
						'\'23',
					];

// export
exports.yTickLabelBars = yTickLabelBars;